/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useState } from "react";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import { popupcontext } from "../../../../context/Popupscontext";
import Button from "../../../Helpers/Button/Button";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans from "../../../../utils";
import ObjectUsers from "../../../LiveTracking/Object/ObjectUsers/ObjectUsers";

export default function TrackedFilter() {
	const { display, handleShow, setDisplay } = useContext(popupcontext);
	const { setObjectSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	useEffect(() => {
		return () => {
			setQuery(null);
			setObjectSearchQuery(null);
			setDisplay(false);
		};
	}, [setObjectSearchQuery, setDisplay]);
	useEffect(() => {
		return () => {
			setDisplay(false);
		};
	}, [setDisplay]);

	const handleSearch = (e) => {
		setQuery(e.target.value);
		setObjectSearchQuery(e.target.value);
	};
	return (
		<>
			<div
				className="d-flex align-items-center justify-content-between "
				style={{ padding: "12px" }}
			>
				<Searchbar
					style="search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
					width={245}
				/>

				<Button
					text={trans("Groups")}
					type="default"
					htmlType="button"
					onClick={() => {
						handleShow("objectUsers");
					}}
					style={{ width: "69px" }}
				/>
			</div>
			{display && <ObjectUsers />}
		</>
	);
}
